import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  type: "in-progress" | "rejected" | "delivered" | "inactive";
  message: string;
}
const TrackStatus = ({ type, message }: IProps) => {
  return (
    <Container rejected={type === "rejected"}>
      <StatusBar
        bgcolor={
          type === "delivered"
            ? Colors.success
            : type === "rejected"
            ? Colors.danger
            : Colors.yellow500
        }
      />
      <IconContainer>
        {type === "in-progress" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              fill="#FEA101"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V11.6893L15.0303 13.9697C15.3232 14.2626 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2626 15.3232 13.9697 15.0303L11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V8C11.25 7.58579 11.5858 7.25 12 7.25Z"
              fill="#1E1E1E"
            />
          </svg>
        ) : type === "delivered" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
              fill="#5AB400"
            />
          </svg>
        ) : type === "rejected" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.96963 8.96965C9.26252 8.67676 9.73739 8.67676 10.0303 8.96965L12 10.9393L13.9696 8.96967C14.2625 8.67678 14.7374 8.67678 15.0303 8.96967C15.3232 9.26256 15.3232 9.73744 15.0303 10.0303L13.0606 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0303 15.0303C9.73742 15.3232 9.26254 15.3232 8.96965 15.0303C8.67676 14.7374 8.67676 14.2625 8.96965 13.9697L10.9393 12L8.96963 10.0303C8.67673 9.73742 8.67673 9.26254 8.96963 8.96965Z"
              fill="#FF3333"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
              fill="#FEA101"
            />
          </svg>
        )}{" "}
      </IconContainer>
      <TextContainer>
        <Typography size="xl" m_size="lg" weight="semibold" mb="1.2" m_mb="0.4">
          {type === "delivered"
            ? "Delivered"
            : type === "in-progress"
            ? "In Progress"
            : type === "rejected"
            ? "Rejected"
            : "Inactive"}
        </Typography>
        <Typography m_size="s" color={Colors.grey400}>
          {message}
        </Typography>
        {type === "rejected" ? (
          <Buttons>
            <Button>
              <ButtonIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M10.1547 3.48822L12.512 5.84555M11.1547 2.48822C11.4673 2.17562 11.8912 2 12.3333 2C12.7754 2 13.1994 2.17562 13.512 2.48822C13.8246 2.80082 14.0002 3.2248 14.0002 3.66689C14.0002 4.10897 13.8246 4.53295 13.512 4.84555L4.33333 14.0242H2V11.6429L11.1547 2.48822Z"
                    stroke="#FEA101"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </ButtonIcon>
              <Typography weight="medium" color={Colors.yellow500}>
                Edit Metadata
              </Typography>
            </Button>
            <Button>
              <ButtonIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M8.00065 14.6668C11.6825 14.6668 14.6673 11.6821 14.6673 8.00016C14.6673 4.31826 11.6825 1.3335 8.00065 1.3335C4.31875 1.3335 1.33398 4.31826 1.33398 8.00016C1.33398 11.6821 4.31875 14.6668 8.00065 14.6668Z"
                    stroke="#FF3333"
                  />
                  <path
                    d="M9.66733 6.33351L6.334 9.66683M6.33398 6.3335L9.66733 9.66683"
                    stroke="#FF3333"
                    stroke-linecap="round"
                  />
                </svg>
              </ButtonIcon>
              <Typography weight="medium" color={Colors.danger}>
                Abort Release
              </Typography>
            </Button>
          </Buttons>
        ) : (
          <></>
        )}
      </TextContainer>
    </Container>
  );
};

export default TrackStatus;

const Container = styled.div<{ rejected: boolean }>`
  margin-top: 4.6rem;
  width: 100%;
  padding-right: 1.6rem;
  background-color: ${Colors.grey700};
  position: relative;
  border-radius: 0px 8px 8px 0px;
  display: flex;
  align-items: center;
  height: ${(props) => (props.rejected ? "14rem" : "8.6rem")};
`;

const StatusBar = styled.div<{ bgcolor: string }>`
  height: 100%;
  margin-right: 1.2rem;
  width: 0.4rem;
  border-radius: 0px 8px 8px 0px;
  background: ${(props) => props.bgcolor};
`;

const IconContainer = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  margin-right: 2.4rem;
  @media only screen and (max-width: 769px) {
    width: 5rem;
    height: 5rem;
    margin-right: 1rem;
  }
`;

const TextContainer = styled.div``;

const Buttons = styled.div`
  margin-top: 2rem;
  display: grid;
  grid-template-columns: 12rem 12rem;
  grid-column-gap: 1.6rem;
`;

const Button = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const ButtonIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 0.4rem;
`;
